<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4 pt-4">
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="grid w-full">
      @if (paymentPageLinkData.type === 'DONATION') {
        <div class="col-12 flex flex-column gap-2">
          <p-select-button [options]="amountTypeOptions"
                           [(ngModel)]="paymentPageLinkData.amountType"
                           [allowEmpty]="false"
                           optionLabel="label"
                           optionValue="value">
          </p-select-button>
        </div>
      }
      <div class="col-6 flex flex-column gap-2">
        <label for="currency">
          {{ i18n.i18nLng()['CURRENCY'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="paymentPageLinkData.currency"
                  inputId="currency"
                  [options]="settingsProvider.currencyList"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="dataChanged.emit()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['CURRENCY']"
                  [attr.aria-invalid]="paymentPageLinkInvalidFlags.currency"
                  [attr.aria-describedby]="paymentPageLinkInvalidFlags.currency ? 'currency-invalid-help' : null"
                  [ngClass]="paymentPageLinkInvalidFlags.currency ? 'ng-invalid ng-dirty' : null"/>
        @if (paymentPageLinkInvalidFlags.currency) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="currency-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      @if (paymentPageLinkData.type === 'DONATION') {
        <div class="col-6 flex flex-column">
        </div>
        @if (paymentPageLinkData.amountType == 'FIXED') {
          <div class="col-4 flex flex-column gap-2">
            <label for="amount">
              {{ i18n.i18nLng()['AMOUNT'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-input-number inputId="amount"
                            fluid
                            mode="decimal"
                            [autofocus]="true"
                            [(ngModel)]="newDonationAmount"
                            [min]="0.01"
                            [max]="999999.99"
                            [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                            [inputStyleClass]="paymentPageLinkInvalidFlags.amount ? 'ng-invalid ng-dirty' : null"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            [attr.aria-invalid]="paymentPageLinkInvalidFlags.amount"
                            [attr.aria-describedby]="paymentPageLinkInvalidFlags.amount ? 'amount-invalid-help' : 'fixed-amount-help'"
                            (keydown.enter)="addDonationAmount()"
                            size="large">
            </p-input-number>
            @if (paymentPageLinkInvalidFlags.amount) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="amount-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            } @else {
              <small style="line-height: 1.5rem" role="contentinfo" id="fixed-amount-help">{{ i18n.i18nLng()['CONFIRMAMOUNT'] }}</small>
            }
          </div>
          <div class="col-8 flex chip-container">
            @for (amount of paymentPageLinkData.donationAmountList; track amount) {
              <p-chip [label]="((amount / 100) | number:'1.2-2') + ' ' + (paymentPageLinkData.currency === 'EUR' ? '€' : paymentPageLinkData.currency)"
                      [removable]="true"
                      (onRemove)="removeDonationAmount(amount)">
              </p-chip>
            }
          </div>
          <div class="col-12 flex align-items-center">
            <p-checkbox inputId="custom-amount-option" [(ngModel)]="paymentPageLinkData.customAmountOption" [binary]="true" size="large"/>
            <label for="custom-amount-option" class="ml-2 text-lg">{{ i18n.i18nLng()['CUSTOMAMOUNTOPTION'] }}</label>
          </div>
        }
      } @else {
        <div class="col-6 flex flex-column gap-2">
          <label for="amount">
            {{ i18n.i18nLng()['AMOUNT'] }}<sup class="sps-sup">*</sup>
          </label>
          <p-input-number inputId="amount"
                          fluid
                          mode="decimal"
                          [autofocus]="true"
                          [(ngModel)]="paymentPageLinkData.amount"
                          [required]="true"
                          (ngModelChange)="dataChanged.emit()"
                          [min]="0.01"
                          [max]="999999.99"
                          [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                          [inputStyleClass]="paymentPageLinkInvalidFlags.amount ? 'ng-invalid ng-dirty' : null"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                          [attr.aria-invalid]="paymentPageLinkInvalidFlags.amount"
                          [attr.aria-describedby]="paymentPageLinkInvalidFlags.amount ? 'amount-invalid-help' : null"
                          size="large">
          </p-input-number>
          @if (paymentPageLinkInvalidFlags.amount) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="amount-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
        </div>
      }
    </div>
  </fieldset>

  <fieldset class="sps-fieldset form-data-container separator">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ addPaymentPageLinkDialog.linkType === 'PAYMENT' ? i18n.i18nLng()['PAYMENTLINKVALIDITY'] : i18n.i18nLng()['DONATIONLINKVALIDITY'] }}<sup class="sps-sup">*</sup></legend>
    </div>
    <div class="grid w-full align-items-center">
      <div class="col-6 flex gap-2">
        <p-radio-button inputId="link-validity-unlimited"
                        value="UNLIMITED"
                        [(ngModel)]="paymentPageLinkData.linkValidity"
                        (ngModelChange)="dataChanged.emit()"
                        [ngClass]="paymentPageLinkInvalidFlags.linkValidity ? 'ng-invalid ng-dirty' : null"
                        [attr.aria-invalid]="paymentPageLinkInvalidFlags.linkValidity"
                        [attr.aria-describedby]="paymentPageLinkInvalidFlags.linkValidity ? 'link-validity-help' : null">
        </p-radio-button>
        <label class="text-lg" for="link-validity-unlimited">{{ i18n.i18nLng()['LINKVALIDITYUNLIMITED'] }}</label>
      </div>
      <div class="col-6 flex align-items-center gap-2">
        <div class="flex gap-2" style="width: 150px">
          <p-radio-button inputId="link-validity-date"
                          value="DATE"
                          [(ngModel)]="paymentPageLinkData.linkValidity"
                          (ngModelChange)="dataChanged.emit()"
                          [ngClass]="paymentPageLinkInvalidFlags.linkValidity ? 'ng-invalid ng-dirty' : null"
                          [attr.aria-invalid]="paymentPageLinkInvalidFlags.linkValidity"
                          [attr.aria-describedby]="paymentPageLinkInvalidFlags.linkValidity ? 'link-validity-help' : null">
          </p-radio-button>
          <label class="text-lg" for="link-validity-date">{{ i18n.i18nLng()['VALIDITYDATE'] }}</label>
        </div>
        @if (paymentPageLinkData?.linkValidity !== 'UNLIMITED') {
          <p-date-picker inputId="expiration-date"
                         class="full-date-picker"
                         [fluid]="true"
                         [(ngModel)]="paymentPageLinkData.expirationDate"
                         (ngModelChange)="dataChanged.emit()"
                         [ngClass]="paymentPageLinkInvalidFlags.expirationDate ? 'ng-invalid ng-dirty' : null"
                         [showIcon]="true"
                         [iconDisplay]="'input'"
                         appendTo="body"
                         dateFormat="dd.mm.yy"
                         placeholder="tt.mm.jjjj"
                         [attr.aria-invalid]="paymentPageLinkInvalidFlags.expirationDate"
                         [attr.aria-describedby]="paymentPageLinkInvalidFlags.expirationDate ? 'expiration-date-help' : null">
          </p-date-picker>
        }
      </div>
      @if (paymentPageLinkInvalidFlags.linkValidity || paymentPageLinkInvalidFlags.expirationDate) {
        <div class="col-6">
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="link-validity-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        </div>
        <div class="col-6">
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="expiration-date-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        </div>
      }
    </div>
  </fieldset>

  <fieldset class="sps-fieldset form-data-container separator">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ i18n.i18nLng()['PAYMENTATTEMPTS'] }}<sup class="sps-sup">*</sup></legend>
    </div>
    <div class="grid w-full align-items-center">
      <div class="col-4 flex gap-2">
        <p-radio-button inputId="frequency-unlimited"
                        value="UNLIMITED"
                        [(ngModel)]="paymentPageLinkData.paymentFrequency"
                        (ngModelChange)="dataChanged.emit()"
                        [ngClass]="paymentPageLinkInvalidFlags.paymentFrequency  ? 'ng-invalid ng-dirty' : null"
                        [attr.aria-invalid]="paymentPageLinkInvalidFlags.paymentFrequency"
                        [attr.aria-describedby]="paymentPageLinkInvalidFlags.paymentFrequency ? 'frequency-help' : null">
        </p-radio-button>
        <label class="text-lg" for="frequency-unlimited">{{ i18n.i18nLng()['FREQUENCYUNLIMITEDLABEL'] }}</label>
      </div>
      <div class="col-4 flex gap-2">
        <p-radio-button inputId="frequency-onetime"
                        value="ONETIME"
                        [(ngModel)]="paymentPageLinkData.paymentFrequency"
                        (ngModelChange)="dataChanged.emit()"
                        [ngClass]="paymentPageLinkInvalidFlags.paymentFrequency ? 'ng-invalid ng-dirty' : null"
                        [attr.aria-invalid]="paymentPageLinkInvalidFlags.paymentFrequency"
                        [attr.aria-describedby]="paymentPageLinkInvalidFlags.paymentFrequency ? 'frequency-help' : null">
        </p-radio-button>
        <label class="text-lg" for="frequency-onetime">{{ i18n.i18nLng()['FREQUENCYONETIMELABEL'] }}</label>
      </div>
      <div class="col-4 flex gap-2">
        <p-radio-button inputId="frequency-onetry"
                        value="ONETRY"
                        [(ngModel)]="paymentPageLinkData.paymentFrequency"
                        (ngModelChange)="dataChanged.emit()"
                        [ngClass]="paymentPageLinkInvalidFlags.paymentFrequency ? 'ng-invalid ng-dirty' : null"
                        [attr.aria-invalid]="paymentPageLinkInvalidFlags.paymentFrequency"
                        [attr.aria-describedby]="paymentPageLinkInvalidFlags.paymentFrequency ? 'frequency-help' : null">
        </p-radio-button>
        <label class="text-lg" for="frequency-onetry">{{ i18n.i18nLng()['FREQUENCYONETRYLABEL'] }}</label>
      </div>
      @if (paymentPageLinkInvalidFlags.paymentFrequency) {
        <div class="col-12">
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="frequency-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        </div>
      }
    </div>
  </fieldset>

  <fieldset class="sps-fieldset form-data-container separator">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ i18n.i18nLng()['PAYMENTTYPES'] }}<sup class="sps-sup">*</sup></legend>
    </div>
    <div class="grid w-full">
      <div class="col-12">
        <div style="max-width: 637px;">
          <p-pickList [source]="availablePaymentMethods"
                      [target]="selectedPaymentMethods"
                      [dragdrop]="false"
                      [showSourceControls]="false"
                      [showTargetControls]="false"
                      styleClass="w-full"
                      [ngClass]="paymentPageLinkInvalidFlags.paymentMethodIds ? 'ng-invalid ng-dirty' : null"
                      [rightButtonAriaLabel]="i18n.i18nLng()['ADDPAYMENTTYPE']"
                      [leftButtonAriaLabel]="i18n.i18nLng()['REMOVEPAYMENTTYPE']"
                      [allRightButtonAriaLabel]="i18n.i18nLng()['ADDALLPAYMENTTYPES']"
                      [allLeftButtonAriaLabel]="i18n.i18nLng()['REMOVEALLPAYMENTTYPES']"
                      [attr.aria-label]="i18n.i18nLng()['PAYMENTTYPES']"
                      [attr.aria-invalid]="paymentPageLinkInvalidFlags.paymentMethodIds"
                      [attr.aria-describedby]="paymentPageLinkInvalidFlags.paymentMethodIds ? 'payment-methods-help' : null"
                      (onMoveToTarget)="addPaymentMethod($event)"
                      (onMoveAllToTarget)="addPaymentMethods($event)"
                      (onMoveToSource)="removePaymentMethod($event)"
                      (onMoveAllToSource)="removePaymentMethods($event)">
            <ng-template #item let-item>
              <div class="flex align-items-center gap-2 overflow-hidden" [pTooltip]="item.title + ' (' + item.projectId  + ')'">
                @if (!item.customIcon) {
                  <i class="icon" [ngClass]="item.icon"></i>
                } @else {
                  <sps-custom-icon [name]="item.icon" [size]="14"></sps-custom-icon>
                }
                <div class="picklist-item-label">{{ item.title + ' (' + item.projectId  + ')' }}</div>
              </div>
            </ng-template>
          </p-pickList>
        </div>
        @if (paymentPageLinkInvalidFlags.paymentMethodIds) {
          <div class="mt-2">
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="payment-methods-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          </div>
        }
      </div>
    </div>
  </fieldset>
</div>
